// extracted by mini-css-extract-plugin
export var outlined = "button-module--outlined--OHs75";
export var root = "button-module--root--Muq0L";
export var solid = "button-module--solid--kr7mk";
export var text = "button-module--text--eWLlf";